import { PostTitle } from '@buildwise/libs/posts';
import { Box, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { VIEW_ARTICLE } from 'constants/routes';
import { PromptSummaryReferenceType } from './hooks/useBuildWiseGPTHistoryQuery';
import { Link, useLocation, useSearchParams } from 'react-router-dom';

type ReferenceItemProps = {
  reference: PromptSummaryReferenceType;
  refIndex: number;
};

function ReferenceItem({ reference, refIndex }: ReferenceItemProps) {
  const { state } = useLocation();
  const [searchParams] = useSearchParams();

  return (
    <RefContainer>
      <Box display="flex">
        <Box>
          <Link
            to={`${VIEW_ARTICLE.replace(':articleId', reference?.id || '')}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`}
            state={{
              ...state,
              article: reference,
            }}
            target="_blank"
            style={{
              textDecoration: 'none',
              width: 'fit-content',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box
              sx={(theme) => ({
                display: 'inline',
                px: 0.5,
                mr: 1,
                border: `1px solid ${theme.palette.custom.divider}`,
                borderRadius: '4px',
                fontSize: 11,
                color: theme.palette.custom.tuna,
                backgroundColor: theme.palette.custom.background,
                '&:hover': {
                  color: theme.palette.custom.link,
                  borderColor: theme.palette.custom.link,
                  backgroundColor: theme.palette.custom.mariner01,
                },
              })}
            >
              {refIndex + 1}
            </Box>
            <PostTitle
              title={reference?.title}
              variant="related-post"
              sx={(theme) => ({
                fontWeight: 500,
                '&:hover': {
                  color: theme.palette.custom.link,
                  textDecoration: 'underline',
                  width: 'fit-content',
                },
              })}
            />
          </Link>
        </Box>
      </Box>
    </RefContainer>
  );
}

const RefContainer = styled(Paper)(({ theme }) => ({
  width: 'fit-content',
  backgroundColor: theme.palette.custom.background,
  boxShadow: `0 4px 24px ${theme.palette.custom.boxShadow}`,
  borderRadius: 8,
  padding: '4px 6px',
  marginBottom: 4,
  border: `1px solid ${theme.palette.custom.divider}`,
  fontSize: 11,
  color: theme.palette.custom.tuna,
}));

export default ReferenceItem;
